class SwipperCustom {
  constructor() {
    this._swipperClientes();
  }
  _swipperClientes() {

    var swiper = new Swiper(".swiperClientes", {
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      loop: true,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
    });

  }

}